import * as React from "react";
const SvgSentimentSatisfied = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 9.5,
  r: 1.5,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 9.5,
  r: 1.5,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88a5.495 5.495 0 0 0 10.24 0h-1.67c-.7 1.19-1.97 2-3.45 2z",
  fill: "currentColor"
}));
export default SvgSentimentSatisfied;